import React from 'react';

import { useTranslation } from 'react-i18next';

import AccumulatedCardBalance from './components/AccumulatedCardBalance/AccumulatedCardBalance';
import CurrentCycleCard from './components/CurrentCycleCard/CurrentCycleCard';
import HistoryCard from './components/HistoryCard/HistoryCard';
import BdsCardContainer from '../../../../shared/components/v3/Cards/BdsCardContainer/BdsCardContainer';
import EmptyCard from '../../../../shared/components/v3/Cards/EmptyCard/EmptyCard';
import useCollaboratorConsumptions from '../../../../shared/hooks/useCollaboratorConsumptions/useCollaboratorConsumptions';
import { TRANSLATION_COLLABORATORS } from '../../../../shared/translations/collaborators';
import { getCycleLabel } from '../../../../shared/utils/flexibleRemuneration/payrollMonths';

import './CollaboratorBalance.scss';

interface ICollaboratorBalance {
  email: string;
}

const CollaboratorBalance = ({ email }: ICollaboratorBalance) => {
  const { t } = useTranslation();
  const { collaboratorBalanceRF } = TRANSLATION_COLLABORATORS.detail;
  const { openCycle, currentCycle, cardBalances, history, refetch } = useCollaboratorConsumptions(
    email,
    Boolean(email)
  );

  const allServicesFailed = history.error && cardBalances.error;
  const finishedLoading = !currentCycle.loading && !history.loading && !cardBalances.loading;
  const hasConsumptions = (currentCycle.data?.hasData ?? false) || history.data.some((year) => year.total.hasData);
  const hasCardBalance = Boolean(cardBalances.data) && (cardBalances.data?.total ?? 0) > 0;
  const isEmpty = allServicesFailed || (finishedLoading && !hasConsumptions && !hasCardBalance);

  if (isEmpty) {
    return (
      <BdsCardContainer
        className="collaborator-balance-section flex flex-col w-full"
        paddingSize="padding-l"
        type="solid"
        borderRadiusSize="radius-l"
      >
        <EmptyCard
          className="collaborator-balance-empty"
          primaryText={t(collaboratorBalanceRF.empty.title)}
          secondaryText={t(collaboratorBalanceRF.empty.description)}
          center
        />
      </BdsCardContainer>
    );
  }

  return (
    <>
      <BdsCardContainer
        className="collaborator-balance-section flex flex-col w-full"
        paddingSize="padding-l"
        type="solid"
        borderRadiusSize="radius-l"
      >
        <CurrentCycleCard currentCycle={currentCycle} cycleLabel={getCycleLabel(openCycle)} />
      </BdsCardContainer>
      <BdsCardContainer
        className="collaborator-balance-section flex flex-col w-full"
        paddingSize="padding-l"
        type="solid"
        borderRadiusSize="radius-l"
      >
        <AccumulatedCardBalance
          balances={cardBalances.data}
          loading={cardBalances.loading}
          error={cardBalances.error}
          onRetry={refetch}
        />
      </BdsCardContainer>
      <BdsCardContainer
        className="collaborator-balance-section flex flex-col w-full"
        paddingSize="padding-l"
        type="solid"
        borderRadiusSize="radius-l"
      >
        <HistoryCard history={history} onRetry={refetch} />
      </BdsCardContainer>
    </>
  );
};

export default CollaboratorBalance;
